import { useMemo } from "react";
/**
 * Hook to format value as currency or number
 */
export const useFormattedValue = (value, formatCurrency = false) => {
  return useMemo(() => {
    return formatCurrency
      ? new Intl.NumberFormat("en-GB", {
          style: "currency",
          currency: "GBP",
          minimumFractionDigits: 0,
        }).format(value)
      : new Intl.NumberFormat("en-GB", {
          minimumFractionDigits: 0,
        }).format(value);
  }, [value, formatCurrency]);
};
